export const updateSpecificKeys = (
  arr1: any[],
  arr2: any[],
  keysToUpdate: { name: string; type: string }[],
) =>
  arr1.map((obj1: any) => {
    const obj2: any = arr2.find((o) => o.idMessage === obj1.idMessage);
    if (obj2) {
      keysToUpdate.forEach((key) => {
        if (key.name in obj2) {
          // eslint-disable-next-line no-param-reassign
          obj1[key.name] = obj2[key.name].toString();
          // eslint-disable-next-line no-param-reassign
          obj1.isValid = true;
        }
      });
    }
    return obj1;
  });

const replaceEmptyStrings = (obj: any) =>
  Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [key, typeof value === "boolean" ? false : null]),
  );

export const buildCustomKeysObject = (
  messages: any,
  adapterInterfaceKeys: any,
  protocolType: string,
) =>
  messages.map((msg: any) => ({
    isValid: false,
    idKey: "",
    duplicatedValue: "",
    methodType: "POST",
    idMessage: msg.id,
    message: msg.short_message,
    type: msg.message_type.name,
    idType: msg.message_type_id,
    contentType: null,
    lower_message_id: null,
    units_based: protocolType.toLocaleLowerCase() === "ln1",
    floors_based: false,
    debounce_time: null,
    ...replaceEmptyStrings(adapterInterfaceKeys),
  }));

export const buildAssignedKeysobject = (data: any, keys: any) => {
  const copy = structuredClone(data);
  keys.forEach((item: any) => {
    const index = copy.findIndex((x: any) => x.idMessage === item.message_id);
    if (index >= 0) {
      const target = copy[index];
      target.isValid = true;
      target.idKey = item.id;
      target.methodType = "PUT";
      target.contentType = item.content_type;
      target.lower_message_id = item.lower_message_id;
      target.units_based = item.units_based;
      target.floors_based = item.floors_based;
      target.debounce_time = item.debounce_time ?? null;
      Object.entries(item.value).forEach(([key, value]) => {
        target[key] = value;
      });
    }
  });
  return copy;
};

// eslint-disable-next-line arrow-body-style
export const buildOffsetsTable = (messageTypes: any[], units: number) => {
  return messageTypes.flatMap((messageType) => {
    const baseRow: any = {
      idMessageType: messageType.id,
      isValid: false,
      type: messageType.name,
    };

    for (let i = 0; i < units; i += 1) {
      baseRow[`car_${i}`] = null;
    }

    if (messageType.name.toUpperCase() === "TRAFFIC") {
      const subTypes = [
        "",
        "TRAFFIC",
        "P",
        "CarCall",
        "RearCarCall",
        "HallCall",
        "UpHallCall",
        "UpRearHallCall",
        "DownHallCall",
        "DownRearHallCall",
      ];

      return subTypes.map((subType) => ({
        ...baseRow,
        // eslint-disable-next-line prefer-template
        id: Math.random().toString(36).substring(2, 10) + "-" + Date.now(),
        subType,
      }));
    }

    if (messageType.name.toUpperCase() === "STATUS") {
      const subTypes = ["", "STATUS", "Heartbeat"];

      return subTypes.map((subType) => ({
        ...baseRow,
        // eslint-disable-next-line prefer-template
        id: Math.random().toString(36).substring(2, 10) + "-" + Date.now(),
        subType,
      }));
    }

    if (messageType.name.toUpperCase() === "CONTROL") {
      const subTypes = [
        "",
        "CONTROL",
        "CarCallLock",
        "CarCallUnlock",
        "RearCarCallLock",
        "RearCarCallUnlock",
        "UpHallCallLock",
        "UpHallCallUnlock",
        "UpRearHallCallLock",
        "UpRearHallCallUnlock",
        "UpAssignedHallCall",
        "UpAssignedRearHallCall",
        "DownHallCallLock",
        "DownHallCallUnlock",
        "DownRearHallCallLock",
        "DownRearHallCallUnlock",
        "DownAssignedHallCall",
        "DownAssignedRearHallCall",
        "EnergizeCarCall",
        "EnergizeRearCarCall",
        "EnergizeUpHallCall",
        "EnergizeUpRearHallCall",
        "EnergizeDownHallCall",
        "EnergizeDownRearHallCall",
        "SecureCarCall",
        "SecureRearCarCall",
        "VIP",
      ];

      return subTypes.map((subType) => ({
        ...baseRow,
        // eslint-disable-next-line prefer-template
        id: Math.random().toString(36).substring(2, 10) + "-" + Date.now(),
        subType,
      }));
    }

    return {
      ...baseRow,
      // eslint-disable-next-line prefer-template
      id: Math.random().toString(36).substring(2, 10) + "-" + Date.now(),
      subType: "",
    };
  });
};

export const buildPreviousOffsets = (offsetsTable: any, previousOffsets: any) => {
  const updatedArray = offsetsTable.map((item: any) => {
    const updatedItem = { ...item };
    previousOffsets.forEach((update: any) => {
      if (item && item.subType && item.sybType !== "") {
        if (update.message_sub_type === item.subType) {
          const key = `car_${update.unit_number}`;
          updatedItem[key] = update.offset;
          updatedItem.isValid = true;
        }
      } else {
        // eslint-disable-next-line no-lonely-if
        if (update.message_type === item.idMessageType && update.message_sub_type === "") {
          const key = `car_${update.unit_number}`;
          updatedItem[key] = update.offset;
          updatedItem.isValid = true;
        }
      }
    });
    return updatedItem;
  });
  return updatedArray;
};
